import React, {useEffect, useState} from 'react';
import {Table} from 'antd';
import DynamicSearchForm from '../../CommonComponents/DynamicSearch';
import {useNavigate} from 'react-router-dom';
import {
  PageSizeArray,
  PaginationPosition,
  ReturnNAOnEmpty,
  eventOptionGroupFilters,
  formatCurrency,
} from '../../../Util/commonUtility';
import AdminActionsDropdown from '../../CommonComponents/AdminActionsDropdown/AdminActionsDropdown';
import {useSelector} from 'react-redux';
import HeaderSearchCard from '../../CommonComponents/HeaderSearchCard';
import {CREATE} from '../../../Constant/enums';
import useLocalization from '../../../Localization';

const EventOptionGroupsComponent = (props) => {
  const [expanded, setExpanded] = useState(false);
  let navigate = useNavigate();
  const {ApplicationString} = useLocalization();

  const {
    alleventOptionGroupsData,
    handlePaginationChange,
    paging,
    sortParams,
    handleTableChange,
    fetchEventOptionGroups,
    deleteEventOptionGroups,
    searchValues,
  } = props;
  const ps = useSelector(
    ({pageSizes}) => pageSizes.pageSizes.eventOptionGroups,
  );
  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    searchValues && setExpanded(true);
  }, [searchValues]);

  const handleSearch = (values) => {
    fetchEventOptionGroups(values);
  };

  const handleEditClick = async (id) => {
    navigate(`/admin/eventOptionGroups/update/${id}`);
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      width: '1%',
    },
    {
      title: 'Name',
      dataIndex: 'name',
      width: '6%',
    },
    {
      title: 'Details',
      dataIndex: 'details',
      width: '6%',
    },
    {
      title: 'Price',
      dataIndex: 'price',
      width: '6%',
      render: (text) =>
        text === null || text === undefined || text === ''
          ? ReturnNAOnEmpty(text)
          : formatCurrency(text),
    },

    {
      title: '',
      key: 'action',
      width: '2%',
      render: (_, record) => (
        <AdminActionsDropdown
          record={record}
          editBool={true}
          deleteBool={true}
          handleDeleteClick={deleteEventOptionGroups}
          handleEditClick={handleEditClick}
          text='Event Option Group'
          resource='event_option_groups'
        />
      ),
    },
  ];
  columns.forEach((column) => {
    if (column.key !== 'action') {
      column.sorter = true;
      column.sortOrder =
        sortParams.field === column.dataIndex && sortParams.order;
    }
  });
  return (
    <div className='main-container'>
      <HeaderSearchCard
        resource='event_option_groups'
        buttonTitle={
          ApplicationString['eventOptionGroupsComponent.button.addForm']
        }
        toggleClick={toggleExpand}
        addClick={() => navigate('/admin/eventOptionGroups/add')}
        dataTestId='adminEventOptionGroups-button-addEventOptionGroups'
        permission={CREATE}
        expanded={expanded}
      />
      {expanded && (
        <DynamicSearchForm
          columns={eventOptionGroupFilters}
          onSearch={handleSearch}
          savedFilteredValues={searchValues}
          title={'events_option_groups'}
        />
      )}
      <div className='listing-container'>
        <Table
          bordered
          className='admin-table'
          columns={columns}
          dataSource={alleventOptionGroupsData}
          rowKey={'id'}
          scroll={{x: 786}}
          onChange={handleTableChange}
          sticky={true}
          pagination={{
            onChange: (page, pageSize) => {
              handlePaginationChange(page, pageSize);
            },
            current: paging.page,
            total: paging.totalCount,
            pageSize: ps || paging.pagecount,
            pageSizeOptions: PageSizeArray,
            showSizeChanger: true,
            showQuickJumper: true,
            onShowSizeChange: (page, pageSize) => {
              handlePaginationChange(page, pageSize);
            },
            showTotal: (total, range) => `Total ${total} items`,
            position: [PaginationPosition],
          }}
        />
      </div>
    </div>
  );
};

export default EventOptionGroupsComponent;
